module.exports = __webpack_public_path__ + "img/green_rectangle.c9f51f99.png";